import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { RetrieveBookingInitStepDeclaration } from "./Steps/RetrieveBookingInitStep";

export const RetrieveBookingStartupFlow = new FlowDefinition("RetrieveBookingFlow");

RetrieveBookingStartupFlow.addStep(RetrieveBookingInitStepDeclaration);

// RetrieveBookingStartupFlow.addLink("RetrieveBookingInit_Step", "CheckoutFlow")

// RetrieveBookingStartupFlow.addTransition(RetrieveBookingTransition, "RetrieveBookingInit_Step")

RetrieveBookingStartupFlow.setStartStep("RetrieveBookingInit_Step");

export const RetrieveBookingStartupStepDefinition = new StepDefinition({
    stepName: "RetrieveBookingFlow",
    stepFlow: RetrieveBookingStartupFlow,
    contextIsolation: false
})
